import React, { useState } from 'react';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Divider from '@mui/material/Divider';
import Colors from '../../library/Colors';

const SwitchSetting = (props) => {
    const [checkedState, setCheckedState] = useState(parseInt(props.checked) === 1 ? true : false);
    if(SftGlobalData.debug){console.log("SWITCH", props)};

    const submitHandler = async (value) => {
      let postData = {
          key: props.api,
          category: props.category,
          setting: props.setting,
          value: value ? "1" : "0"
      };
      if(props.groupId !== '0000'){
        postData.groupId = props.groupId;
      }
      SftGlobalData.post('mobileSettings&action=editSettings', postData).then(response => {

      })
    }

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, py: 1.5 }}>
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 600 }}>{props.title}</Typography>
                    {props.description && props.description !== "-" &&
                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>{props.description}</Typography>}
                </Box>
                <Switch
                    checked={checkedState}
                    onChange={() => { submitHandler(!checkedState); setCheckedState(!checkedState); }}
                    sx={{
                        flexShrink: 0,
                        '& .MuiSwitch-switchBase.Mui-checked': { color: Colors.sft_blue },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: Colors.sft_blue },
                    }}
                />
            </Box>
            <Divider />
        </Box>
    );
}

export default SwitchSetting;
